export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#261300',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#FF7C00',
  },
  {
    path: 'M434.432 329.216h68.096l140.8 365.568H574.72l-34.304-96.768h-145.92l-34.304 96.768h-66.048z m-22.528 220.16H523.52l-54.784-157.184H467.2zM671.488 329.216h58.368v55.296h-58.368z m0 100.864h58.368v264.704h-58.368z',
    fill: '#FF7C00',
  },
]
